/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';
import 'js-marker-clusterer';

export default class PropertyMap extends PageComponent {
    constructor(element, cluster, marker, template) {
        super(element);
        this._clusterStyles = cluster;
        this._markerStyles = marker;
        this._template = template;
        this._locations = null;

        this.minZoom = null;
        this.maxZoom = null;
        this.infoWindow = null;

        this.callback = null;
    }

    init(){
        this.setupMap();
    }

    get template() {
        return this._template;
    }

    get cluster() {
        return this._clusterStyles;
    }

    get marker() {
        return this._markerStyles;
    }

    get locations() {
        return this._locations;
    }

    set locations(locations) {
        this._locations = locations;
    }

    setupMap(){
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            $.getScript('https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBSf1FusDDIHtc0_BN1bKTGNxNga26N76I', () => this.setupMap());
            return;
        }

        if (!this.map) {
            var opts = {
                zoom: 13,
                center: new google.maps.LatLng(-36.8629408, 174.7253867),
                panControl: false,
                scaleControl: false,
                streetViewControl: false,
                zoomControl: true,
                zoomControlOptions: {style: 'SMALL'}
            };

            this.map = new google.maps.Map(this.domElement(), opts);

            this.clusterer = new MarkerClusterer(this.map, [], {
                gridSize: 30,
                styles: this.cluster,
                maxZoom: 20
            });
        }

        this.executeCallBack();
    }

    executeCallBack() {
        if (typeof this.callback === 'function') {
            this.callback(this._locations);
        }
    }

    updateLocations(locationJSON) {
        var locations = $.parseJSON(locationJSON);
        this._locations = locations;

        var self = this,
            newBounds = new google.maps.LatLngBounds();

        //clear markers on map
        this.clusterer.clearMarkers();

        //add new locations
        $.each(locations, function (index, location) {
            if(location.MostRecentRecord == true){
                var latLng = new google.maps.LatLng(location.Latitude, location.Longitude);

                //check if this point is current bounds of the map and update new bounds
                //update only if its still in auckland
                if(location.Latitude < -36.8313408 &&
                    location.Latitude > -36.9406712 &&
                    location.Longitude < 174.8635149 &&
                    location.Longitude > 174.659878){
                    newBounds.extend(latLng);
                }

                //add marker
                self.clusterer.addMarker(self.getMarker(location, latLng));
            }
        });

        this.map.setOptions({
            maxZoom: this.maxZoom ? this.maxZoom : 14,
            minZoom: this.minZoom ? this.minZoom : 14
        })

        //fit map to markers
        this.map.fitBounds(newBounds);

        //refresh markers
        this.clusterer.redraw();
    }

    getMarker(location, latLng) {
        var flag = this._markerStyles[0];

        if(location.Status == 'Current'){
            flag = this._markerStyles[1];
        }
        else if(location.Status == 'New'){
            flag = this._markerStyles[2];
        }
        else if(location.Status == 'Sold'){
            flag = this._markerStyles[3];
        }
        else if(location.Status == 'OpenHome'){
            flag = this._markerStyles[4];
        }

        var self = this,
            marker = new google.maps.Marker({
                map: this.map,
                position: latLng,
                icon: {
                    anchor: new google.maps.Point(21, 57),
                    size: new google.maps.Size(73, 65),
                    origin: new google.maps.Point(0, 0),
                    url: flag
                }
            });

        //store this so we can trigger a click easily
        location.marker = marker;

        if(location.disableMarketEvent != true){
            google.maps.event.addListener(marker, 'click', function () {
                // self.map.setCenter(latLng);
                // self.map.setZoom(16);
                self.showInfoBox(location, marker);
            });
        }

        return marker;
    }

    showInfoBox(location, marker) {

        let saleHistoryRecords = this._locations.filter((record) => {
            return (location.Latitude == record.Latitude && location.Longitude == record.Longitude && location.SoldDate != record.SoldDate) ? true : false;
        });

        location.SaleHistory = saleHistoryRecords;

        var html = _.template(this.template)(location);

        if (!this.infoWindow) {
            this.infoWindow = new google.maps.InfoWindow({
                content: html
            });
        } else {
            this.infoWindow.setContent(html);
        }

        //delay popup open a split second to ensure html image height is known
        let self = this;
        setTimeout(function () {
            self.infoWindow.open(this.map, marker);
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyMap.js